interface ChatMemoButtonProps {
  onOpen: () => void;
  isOpen: boolean;
  sidebarOpen?: boolean;
}

const ChatMemoButton = ({ onOpen, isOpen, sidebarOpen }: ChatMemoButtonProps) => {
  return (
    <>
      {!isOpen && (
        <button
          onClick={onOpen}
          className={`fixed bottom-5 z-40 rounded-full w-[48px] h-[48px] border border-primary-50 bg-[linear-gradient(144deg,#9FF0E8_13.78%,#FFF9F3_86.08%)] flex items-center justify-center hover:opacity-80 transition-all duration-300 ${
            sidebarOpen ? "right-[410px]" : "right-10"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 19H14V14H19V5H5V19ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V15L15 21H5ZM7 14V12H12V14H7ZM7 10V8H17V10H7Z"
              fill="#333333"
            />
          </svg>
        </button>
      )}
    </>
  );
};

export default ChatMemoButton;
